import Image from 'next/image';
import { CDN2 } from '@/helpers/api';
import Link from 'next/link';
import { Button } from 'antd';

export default function LinksSection() {
  return (
    <div className="w-full bg-white">
      <div className="px-4 md:px-32 xl:px-4 mx-auto w-full flex flex-col justify-between items-center max-w-7xl py-16">
        <h2 className="text-3xl font-bold md:hidden mb-6"
        >Affiliate</h2>
        <div className="flex-1 flex flex-col-reverse md:flex-row items-center w-full md:gap-x-6">
          <div className="flex-1 flex flex-col items-center md:items-start space-y-6">
            <h2 className="text-3xl font-bold hidden md:block"
            >Affiliate</h2>
            <p className="text-base md:text-lg text-center md:text-left">
              <strong>Share exclusive deals</strong> with your audience and <strong>earn for every booking</strong>.
              <strong> Perfect for bloggers, influencers, and content creators</strong>.
              Join now and start earning every time your audience books — it’s <strong>free to join and fast to start</strong>.
            </p>
            <Link href="/affiliate">
              <Button type="primary">
                Join Now
              </Button>
            </Link>
          </div>
          <div className="flex-1 flex justify-end">
            <Image
              src={CDN2() + '/staticmyapp/partnerus/affiliate.png'}
              alt="Affiliate"
              width="448"
              height="448"
              quality={100}
              className="w-40 md:w-[448px] border rounded-lg h-auto"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
